package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class ProjectFile(
    val path: String,
    val content: String,
    val sizeBytes: Long = 0L,
    val isFolder: Boolean = false
)

@Serializable
data class RojoProjectManifest(
    val name: String,
    val tree: Map<String, String> = emptyMap(),
    val files: List<ProjectFile> = emptyList()
)
